import { IconRenderer } from '../../primitives'
import type { IconName } from '../../primitives'
import { cn } from '@/core'

interface FeatureCardProps {
  title: string
  description: string
  icon?: IconName | string
  badge?: string
  className?: string
}

export function FeatureCard({
  title,
  description,
  icon,
  badge,
  className,
}: FeatureCardProps) {
  return (
    <div
      className={cn(
        'group relative overflow-hidden rounded-xl bg-white p-6 shadow-sm border border-gray-200 hover:shadow-lg hover:border-blue-300 transition-all duration-300',
        className,
      )}
    >
      {/* Gradient overlay on hover */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50/0 to-indigo-50/0 group-hover:from-blue-50 group-hover:to-indigo-50 transition-all duration-300" />

      <div className="relative z-10">
        {/* Icon */}
        {icon && (
          <div className="mb-4">
            <IconRenderer
              name={icon}
              className="size-8 text-blue-600 group-hover:scale-110 transition-transform duration-300"
            />
          </div>
        )}

        {/* Badge */}
        {badge && (
          <div className="mb-2 inline-block">
            <span className="inline-flex items-center rounded-full bg-blue-100 px-2.5 py-0.5 text-xs font-medium text-blue-800">
              {badge}
            </span>
          </div>
        )}

        {/* Title */}
        <h3 className="text-lg font-semibold text-gray-900 mb-2 group-hover:text-blue-900 transition-colors">
          {title}
        </h3>

        {/* Description */}
        <p className="text-sm text-gray-600 leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  )
}
